import { Typography, Box } from '@mui/material';
import React, { FC, memo } from 'react';
import { Colors } from 'shared/assets/root-assets/colors';

interface Props {
	title: string;
}

export const FormTitle: FC<Props> = memo(({ title }) => {
	return (
		<Box
			sx={{
				backgroundColor: Colors.yellow,
				width: '100%',
				justifyContent: 'center',
				display: 'flex',
				alignItems: 'center',
				borderTopLeftRadius: '8px',
				borderTopRightRadius: '8px',
				padding: '6px 0',
			}}
		>
			<Typography color={'white'}>{title}</Typography>
		</Box>
	);
});
